// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"03c722b7","455":"9e7291b0","980":"cabb4141"}[chunkId] + ".chunk.js";
};